import React from 'react';
import { SubTitle, Description, Image } from '../../components/layouts';
import { buildImageURL } from '../../helpers';
import './style.scss';

const IMAGE = buildImageURL('/game-2.png');
const IMAGE_M = buildImageURL('/game-m-2.png');

export function GamePlay2({mobile = false}) {
  return (
    <div className="page-section section-game-play-2 inverted">
      <div className="txt-wrapper">
        {!mobile && <SubTitle>
          热血battle，冷静应对
        </SubTitle>}
        {mobile && <SubTitle>
          热血battle<br/>冷静应对
        </SubTitle>}
        <Description>
          采用新一代超导水冷散热技术，总散热面积有进一步提升，大型游戏
          <br/>
          等高性能场景，散热表现非常优秀，激战时刻更需冷静沉着。
        </Description>
      </div>
      <Image className="img-wrapper" src={mobile ? IMAGE_M : IMAGE} />
    </div>
  );
}
